<template>
  <div class="view-login auth mb-5">
    <div class="container">
      <div class="d-flex justify-content-center">
        <div class="column">
          <div class="p-5">
            <h1 class="text-center">
              <img class="img-fluid" src="../assets/logo.png" />
            </h1>
          </div>

          <form
            class="card bg-dark border-0 text-light"
            @submit.prevent="submit"
          >
            <div class="card-body">
              <h4 class="text-center">Faça seu login</h4>
              <p class="text-center mb-4 pb-3">
                Informe seu e-mail e senha
              </p>

              <form-group
                v-model="email"
                id="email"
                type="email"
                placeholder="Digite o email cadastrado"
                :errors="errors.email"
              />

              <form-group
                v-model="password"
                id="password"
                type="password"
                placeholder="Digite a sua senha"
                :errors="errors.password"
              />

              <p class="text-right forgot-link">
                <button
                  type="button"
                  @click="forgotDialog = true"
                  class="btn btn-sm btn-link text-light"
                >
                  ESQUECEU A SENHA?
                </button>
              </p>

              <div class="text-center p-4">
                <button
                  class="btn btn-primary btn-block btn-strong rounded-pill"
                  type="submit"
                  :disabled="loading"
                >
                  <loading :show="loading">ENTRAR</loading>
                </button>
              </div>
            </div>
          </form>

          <div class="card bg-dark border-0 text-light">
            <div class="card-body text-center">
              Ainda não é assinante?
              <a href="https://guerrilhaway.com.br/" class="text-primary"
                >Assinar agora.</a
              >
            </div>
          </div>
        </div>
      </div>
    </div>

    <forgot-password v-model="forgotDialog" />

    <b-modal v-model="firstLoginDialog" centered hide-header hide-footer>
      <div class="p-4 text-center">
        <h3 class="mb-4">Olá, GW! Seja bem vindo ao nosso app!</h3>
        <p class="mb-4">
          Como é a primeira vez que você acessa o appGW, você precisa criar uma
          nova senha, por questões de segurança. É só seguir as instruções que
          acabamos de enviar para para {{ email }}.
        </p>
        <button
          class="btn btn-primary btn-block btn-strong"
          @click="firstLoginDialog = false"
        >
          Ok, entendi!
        </button>
      </div>
    </b-modal>
  </div>
</template>

<script>
import ForgotPassword from "@/components/login/ForgotPassword";

export default {
  name: "login",
  components: {
    ForgotPassword
  },
  data() {
    return {
      email: "",
      password: "",
      errors: {
        email: null,
        password: null,
        non_field_errors: null
      },
      loading: false,
      forgotDialog: false,
      firstLoginDialog: false
    };
  },
  methods: {
    submit() {
      this.$message.hide();

      this.loading = true;

      this.$store
        .dispatch("user/login", {
          email: this.email,
          password: this.password
        })
        .then(data => {
          const enrollment = (data.user.enrollments || []).find(
            e => e.microlearning
          );

          if (enrollment) {
            this.$router.replace({
              name: "short-course",
              params: { id: enrollment.microlearning }
            });
          } else {
            this.$router.replace("/");
          }
        })
        .catch(error => {
          this.errors = error.response.data;
          if (error.response.data.status === "first_login") {
            this.firstLoginDialog = true;
          } else if (this.errors.non_field_errors) {
            this.$message.error(this.errors.non_field_errors[0]);
          } else if (typeof this.errors[0] === "string") {
            this.$message.error(this.errors[0]);
          }
        })
        .finally(() => {
          this.loading = false;
        });
    }
  }
};
</script>

<style lang="scss" scoped>
.view-login {
  width: 100%;
  color: #e1e1e1;

  .forgot-link {
    margin: -15px 0 0;
  }

  @media screen and (max-width: 991px) {
    .card {
      background: transparent !important;
    }

    ::v-deep .form-control {
      border: 1px solid #535353;
    }
  }

  .btn-sm {
    font-size: 12px;
  }

  .column {
    width: 340px;
    max-width: 90%;
  }
}
</style>
